import React from "react";
import { Link } from "react-router-dom";

/** Small reusable CTA strip used at the bottom of every feature & role page. */
export default function FinalCTA({ headline, sub, primaryLabel = "Start free trial", secondaryLabel = "Book a demo" }) {
  return (
    <section className="mk-section relative overflow-hidden" data-testid="mk-final-cta">
      <div className="mk-grid-bg absolute inset-0 opacity-60 pointer-events-none" />
      <div className="mk-container relative z-10">
        <div
          className="rounded-2xl border p-10 md:p-16 text-center relative overflow-hidden"
          style={{
            borderColor: "var(--mk-border-accent)",
            background: "linear-gradient(135deg, rgba(19,93,212,0.14), rgba(214,239,55,0.06) 50%, transparent)",
          }}
        >
          <div className="mk-mono text-[10px] font-bold uppercase tracking-[0.3em] text-[var(--mk-accent)] mb-3">
            Ready when you are
          </div>
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-black tracking-tight mk-display mb-4">
            {headline || "Run maintenance like a platform company."}
          </h2>
          <p className="text-base md:text-lg text-[var(--mk-text-dim)] max-w-2xl mx-auto mb-8">
            {sub || "7-day free trial. No card required. Migrate your existing jobs and suppliers in one afternoon."}
          </p>
          <div className="flex flex-wrap justify-center gap-3">
            <Link to="/signup" className="mk-btn mk-btn-primary text-base px-6 py-3" data-testid="mk-cta-primary">
              {primaryLabel} →
            </Link>
            <Link to="/product/demo" className="mk-btn mk-btn-secondary text-base px-6 py-3" data-testid="mk-cta-secondary">
              {secondaryLabel}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
